import * as React from 'react';
import { cn } from '@/lib/utils';

const QuestionSidebarTime = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-time', 'flex items-center justify-between', 'flex-wrap', 'gap-2', 'mb-4', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarTime.displayName = 'QuestionSidebarTime';

const QuestionSidebarClock = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-question-sidebar-clock',
      'text-base',
      'font-extrabold',
      'text-primary',
      'flex items-center justify-center',
      'flex-wrap',
      // Estilos aninhados para o SVG
      '[&_svg]:h-5',
      '[&_svg]:w-5',
      '[&_svg]:mr-[.3em]',
      className
    )}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarClock.displayName = 'QuestionSidebarClock';

const QuestionSidebarCount = React.forwardRef(({ className, variant, children, ...props }, ref) => {
  const variantClass = variant === 'success' ? 'text-success' : variant === 'error' ? 'text-danger' : '';

  return (
    <span
      ref={ref}
      className={cn('c-question-sidebar-count', 'font-extrabold', variantClass, className)}
      {...props}
    >
      {children}
    </span>
  );
});
QuestionSidebarCount.displayName = 'QuestionSidebarCount';

const QuestionSidebarYesterday = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-question-sidebar-yesterday',
      'bg-white',
      'rounded-xl',
      'p-3',
      'text-neutral',
      'mb-6',
      'shadow-sm',
      // Estilos aninhados
      '[&_strong]:text-primary-dark',
      '[&_p]:mb-0',
      className
    )}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarYesterday.displayName = 'QuestionSidebarYesterday';

export { QuestionSidebarTime, QuestionSidebarClock, QuestionSidebarCount, QuestionSidebarYesterday };
